import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 1679,
	height: 289,
	fill: "none",
	viewBox: "0 0 1679 289",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#031839",
		d: "M120.96 89.4 0 68.05V289h1679V0s-148.91 104.06-343.3 124.63c-43.52 4.6-115 7.74-115 7.74h-86.89s-150.06 17.18-250.44 22.15c-109.8 5.43-284.52 2.4-284.52 2.4l-162.7-12.28h-32.37l-39.19-8.8h-22.15L156.74 89.4h-35.78Z"
	})
});
const SvgMountainsFg = styled(base)({});
export default SvgMountainsFg;
